import { useMemo } from 'react';

import { useSearchParams } from 'react-router-dom';

import dayjs from 'dayjs';

const defaultSearchData = {
  customerName: '',
  communicationMethod: '',
  customerAddress: '',
  status: '',
  offer: '',
  urgency: '',
  fromDate: '',
  toDate: '',
  offset: 0,
  limit: 12,
  quickFilter: 'All',
};

export const useMyAppointmentsSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getString = (key) => searchParams.get(key) ?? '';
  const getNumber = (key, fallback) => {
    const val = searchParams.get(key);
    return val !== null ? Number(val) : fallback;
  };

  const searchData = useMemo(
    () => ({
      customerName: getString('customerName'),
      communicationMethod: getString('communicationMethod'),
      customerAddress: getString('customerAddress'),
      status: getString('status'),
      offer: getString('offer'),
      urgency: getString('urgency'),
      fromDate: getString('fromDate'),
      toDate: getString('toDate'),
      offset: getNumber('offset', 0),
      limit: getNumber('limit', 12),
      quickFilter: searchParams.get('quickFilter') ?? 'All',
    }),
    [searchParams]
  );

  const setSearchData = (updated) => {
    const nextParams = new URLSearchParams();
    const fullSearchData = { ...searchData, ...updated };

    if (!(Object.keys(updated).length === 1 && 'offset' in updated)) {
      fullSearchData.offset = 0;
    }

    ['fromDate', 'toDate'].forEach((field) => {
      if (fullSearchData[field]) {
        fullSearchData[field] = dayjs(fullSearchData[field]).format('YYYY-MM-DD');
      }
    });

    Object.entries(fullSearchData).forEach(([key, value]) => {
      if (value !== '' && value !== null && value !== undefined) {
        nextParams.set(key, value);
      }
    });

    setSearchParams(nextParams, { replace: true });
  };

  const resetSearchData = () => {
    const nextParams = new URLSearchParams();
    Object.entries(defaultSearchData).forEach(([key, value]) => {
      if (value !== '') {
        nextParams.set(key, value);
      }
    });
    setSearchParams(nextParams, { replace: true });
  };

  return {
    searchData,
    setSearchData,
    resetSearchData,
    defaultSearchData,
  };
};
